module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-wasou-hairmake-9593eb098b362e87e32ac99073f6ddbc.png";